import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgLinearLoaderComponent } from './pg-linear-loader.component';
import { PgLinearLoaderMessageComponent } from './pg-linear-loader-message.component';
import { PgLinearLoaderFactoryComponent } from './pg-linear-loader-factory/pg-linear-loader-factory.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    PgLinearLoaderComponent,
    PgLinearLoaderMessageComponent,
    PgLinearLoaderFactoryComponent,
  ],
  exports: [
    PgLinearLoaderComponent,
    PgLinearLoaderMessageComponent,
    PgLinearLoaderFactoryComponent,
  ],
})
export class PgLinearLoaderModule {}
